<template>
    <div class="text-left">
        <div class="text-muted float-right">Connections</div>
        <div v-for="(group, appUuid) in groupedConnections" :key="appUuid" class="py-1">
            <AppLogoWithName :app="_.get(group, [0, 'app'], {})" class="mb-1 mt-3"/>
            <div v-for="connection in group" :key="connection.uuid">
                <AppAuthConnectionsListItem
                    :connection="connection"
                    :selectable="false"
                    @delete="onDelete"
                    @edit="onEdit"/>
            </div>
        </div>
    </div>
</template>

<script>
import AppAuthConnectionsListItem from '../AppAuthConnectionsListItem'
import AppLogoWithName from '../../AppLogoWithName'

export default {
    name: 'AppsConnections',
    components: {AppLogoWithName, AppAuthConnectionsListItem},
    props: {
        connections: {
            type: Array,
            required: true
        }
    },
    computed: {
        groupedConnections() {
            return _.groupBy(this.connections, 'app.uuid')
        }
    },
    methods: {
        onDelete(connection) {
            this.$emit('delete', connection)
        },

        onEdit(connection) {
            this.$emit('edit', connection)
        }
    }
}
</script>
